module.exports = __webpack_public_path__ + "img/rockstar.65245c37.png";